<div class="card campanha-pipeline-card-info campanha-pipeline-card-info-em-analise">
    <div class="card-header">
        <h6 class="card-title">
            Solicitação
        </h6>
    </div>
    <div class="card-body">
        <ul class="list-group list-group-flush">
            <li class="list-group-item">
                <span class="list-group-item-values">
                    <span class="list-group-item-value">
                        <i class="far fa-calendar"></i> {{dataSolicitacaoAnalise | date: 'dd/MM/yyyy'}}
                    </span>
                    <span class="list-group-item-value">
                        <sgt-avatar
                            [settings]="{
                                isShowLabelNameLeft: true,
                                fullName: nomeUsuarioSolicitacaoAnalise,
                                imageUrl: avatarURLUsuarioSolicitacaoAnalise
                            }">
                        </sgt-avatar>
                    </span>
                </span>
            </li>
        </ul>
    </div>
</div>
